import { createSelector } from 'reselect';
import {
  IFacilityState,
  IFacilityStatisticsState,
  IFacilityLocationState,
  IFacilityDetailsState,
  IUpdateFacilityStatusState,
  IUpdateFacilityViewStatusState,
  IFacilityShiftStaticsState,
  IAcceptRejectFacilityDocumentState,
  IFacilitySignupState,
  IFacilityTypesState,
  IFacilityTypeDocumentRequirementsState,
  IFacilityDocumentUploadState,
  IUpdateFacilityViolationFlagState,
  IFacilityUserState,
  IUpdateFacilityProfileState,
  IFacilityProfileState,
  IFacilityShiftHistoryState,
  IFacilityReportStatsState,
  IWorkerAttendanceState,
  IFacilityDashboardStatisticsState,
  IFacilityShiftStatusChartState,
  IFacilityShiftCalendarState,
  IFacilityAssignedWorkersState
} from './types';


const selectFacilityState = (state: { facility: IFacilityState }) => state.facility;
const selectFacilityStatisticsState = (state: { facilityStatistics: IFacilityStatisticsState }) => state.facilityStatistics;
const selectFacilityLocationState = (state: { facilityLocations: IFacilityLocationState }) => state.facilityLocations;
const selectFacilityDetailsState = (state: { facilityDetails: IFacilityDetailsState }) => state.facilityDetails;
const selectFacilityDatesState = (state: { updateFacilityDocumentDates: IUpdateFacilityStatusState }) => state.updateFacilityDocumentDates;
const selectFacilityViewStatusState = (state: { updateFacilityViewStatus: IUpdateFacilityViewStatusState }) => state.updateFacilityViewStatus;
const selectFacilityShiftStaticsState = (state: { facilityShiftStatics: IFacilityShiftStaticsState }) => state.facilityShiftStatics;
const selectAcceptRejectFacilityDocumentState = (state: { acceptRejectFacilityDocument: IAcceptRejectFacilityDocumentState }) => state.acceptRejectFacilityDocument;
const selectFacilitySignupState = (state: { facilitySignup: IFacilitySignupState }) => state.facilitySignup;
const selectFacilityTypesState = (state: { facilityTypes: IFacilityTypesState }) => state.facilityTypes;
const selectFacilityTypeDocumentRequirementsState = (state: { facilityTypeDocumentRequirements: IFacilityTypeDocumentRequirementsState }) => state.facilityTypeDocumentRequirements;
const selectUpdateFacilityViolationFlagState = (state: { updateFacilityViolationFlag: IUpdateFacilityViolationFlagState }) => state.updateFacilityViolationFlag;
const selectFacilityProfileState = (state: { facilityProfile: IFacilityProfileState }) => state.facilityProfile;

export const selectFacilityProfile = createSelector(
  selectFacilityProfileState,
  (facilityProfileState) => facilityProfileState.data
);

export const selectFacilityProfileLoading = createSelector(
  selectFacilityProfileState,
  (facilityProfileState) => facilityProfileState.loading
);

export const selectFacilityProfileError = createSelector(
  selectFacilityProfileState,
  (facilityProfileState) => facilityProfileState.error
);


export const selectAcceptRejectFacilityDocument = createSelector(
  selectAcceptRejectFacilityDocumentState,
  (acceptRejectFacilityDocumentState) => acceptRejectFacilityDocumentState.data
);

export const selectAcceptRejectFacilityDocumentLoading = createSelector(
  selectAcceptRejectFacilityDocumentState,
  (acceptRejectFacilityDocumentState) => acceptRejectFacilityDocumentState.loading
);

export const selectAcceptRejectFacilityDocumentError = createSelector(
  selectAcceptRejectFacilityDocumentState,
  (acceptRejectFacilityDocumentState) => acceptRejectFacilityDocumentState.error
);

export const selectFacilityShiftStatics = createSelector(
  selectFacilityShiftStaticsState,
  (facilityShiftStaticsState) => facilityShiftStaticsState.data
);

export const selectFacilityViewStatus = createSelector(
  selectFacilityViewStatusState,
  (updateFacilityViewStatusState) => updateFacilityViewStatusState
);

export const selectMarkFacilityAsViewedLoading = createSelector(
  selectFacilityViewStatusState,
  (updateFacilityViewStatusState) => updateFacilityViewStatusState.loading
);

export const selectFacilityDocumentDates = createSelector(
  selectFacilityDatesState,
  (updateFacilityDocumentDatesState) => updateFacilityDocumentDatesState.data
);

export const selectUpdateFacilityDocumentDatesLoading = createSelector(
  selectFacilityDatesState,
  (updateFacilityDocumentDatesState) => updateFacilityDocumentDatesState.loading
);

export const selectFacilityList = createSelector(
  selectFacilityState,
  (facilityState) => facilityState.list.results
);

export const selectFacilityListLoading = createSelector(
  selectFacilityState,
  (facilityState) => facilityState.loading
);

export const selectFacilityListError = createSelector(
  selectFacilityState,
  (facilityState) => facilityState.error
);

export const selectFacilityListCount = createSelector(
  selectFacilityState,
  (facilityState) => facilityState.list.count
);


export const selectFacilityStatistics = createSelector(
  selectFacilityStatisticsState,
  (facilityStatisticsState) => facilityStatisticsState.data
);

export const selectFacilityStatisticsLoading = createSelector(
  selectFacilityStatisticsState,
  (facilityStatisticsState) => facilityStatisticsState.loading
);

export const selectFacilityStatisticsError = createSelector(
  selectFacilityStatisticsState,
  (facilityStatisticsState) => facilityStatisticsState.error
);


export const selectFacilityLocations = createSelector(
  selectFacilityLocationState,
  (facilityLocationState) => facilityLocationState.list.results
);

export const selectFacilityLocationsLoading = createSelector(
  selectFacilityLocationState,
  (facilityLocationState) => facilityLocationState.loading
);

export const selectFacilityLocationsError = createSelector(
  selectFacilityLocationState,
  (facilityLocationState) => facilityLocationState.error
);

export const selectFacilityLocationsCount = createSelector(
  selectFacilityLocationState,
  (facilityLocationState) => facilityLocationState.list.count
);

export const selectFacilityDetails = createSelector(
  selectFacilityDetailsState,
  (facilityDetailsState) => facilityDetailsState.data
);

export const selectFacilityDetailsLoading = createSelector(
  selectFacilityDetailsState,
  (facilityDetailsState) => facilityDetailsState.loading
);

export const selectFacilityDetailsError = createSelector(
  selectFacilityDetailsState,
  (facilityDetailsState) => facilityDetailsState.error
);

const selectUpdateFacilityStatusState = (state: { updateFacilityStatus: IUpdateFacilityStatusState }) => state.updateFacilityStatus;

export const selectUpdateFacilityStatus = createSelector(
  selectUpdateFacilityStatusState,
  (updateFacilityStatusState) => updateFacilityStatusState.data
);

export const selectUpdateFacilityStatusLoading = createSelector(
  selectUpdateFacilityStatusState,
  (updateFacilityStatusState) => updateFacilityStatusState.loading
);

export const selectUpdateFacilityStatusError = createSelector(
  selectUpdateFacilityStatusState,
  (updateFacilityStatusState) => updateFacilityStatusState.error
);

export const selectFacilitySignupMessage = createSelector(
  selectFacilitySignupState,
  (signupState) => signupState.data
);

export const selectFacilitySignupLoading = createSelector(
  selectFacilitySignupState,
  (signupState) => signupState.loading
);

export const selectFacilitySignupError = createSelector(
  selectFacilitySignupState,
  (signupState: IFacilitySignupState) => signupState.error
);

export const selectFacilitySignupSelectedFacilityTypeId = createSelector(
  selectFacilitySignupState,
  (signupState: IFacilitySignupState) => signupState.selectedFacilityTypeId
);

export const selectFacilityTypesList = createSelector(
  selectFacilityTypesState,
  (typesState) => typesState.list.results
);

export const selectFacilityTypesLoading = createSelector(
  selectFacilityTypesState,
  (typesState) => typesState.loading
);

export const selectFacilityTypesError = createSelector(
  selectFacilityTypesState,
  (typesState: IFacilityTypesState) => typesState.error
);

export const selectFacilityTypesCount = createSelector(
  selectFacilityTypesState,
  (typesState) => typesState.list.count
);

export const selectFacilityTypeDocumentRequirements = createSelector(
  selectFacilityTypeDocumentRequirementsState,
  (requirementsState) => requirementsState.data
);

export const selectFacilityTypeDocumentRequirementsLoading = createSelector(
  selectFacilityTypeDocumentRequirementsState,
  (requirementsState) => requirementsState.loading
);

export const selectFacilityTypeDocumentRequirementsError = createSelector(
  selectFacilityTypeDocumentRequirementsState,
  (requirementsState: IFacilityTypeDocumentRequirementsState) => requirementsState.error
);

const selectFacilityDocumentUploadState = (state: { facilityDocumentUpload: IFacilityDocumentUploadState }) => state.facilityDocumentUpload;

export const selectFacilityDocumentUploadLoading = createSelector(
  selectFacilityDocumentUploadState,
  (uploadState) => uploadState.loading
);

export const selectFacilityDocumentUploadData = createSelector(
  selectFacilityDocumentUploadState,
  (uploadState) => uploadState.data
);

export const selectFacilityDocumentUploadError = createSelector(
  selectFacilityDocumentUploadState,
  (uploadState) => uploadState.error
);

const selectFacilityDocumentUploadState2 = (state: { facilityDocumentUpload: IFacilityDocumentUploadState }) => state.facilityDocumentUpload;

export const selectFacilityDocumentUploadLoading2 = createSelector(
  selectFacilityDocumentUploadState2,
  (uploadState) => uploadState.loading
);

export const selectFacilityDocumentUploadData2 = createSelector(
  selectFacilityDocumentUploadState2,
  (uploadState) => uploadState.data
);

export const selectFacilityDocumentUploadError2 = createSelector(
  selectFacilityDocumentUploadState2,
  (uploadState) => uploadState.error
);

export const selectUpdateFacilityViolationFlagLoading = createSelector(
  selectUpdateFacilityViolationFlagState,
  (state) => state.loading
);

export const selectUpdateFacilityViolationFlagError = createSelector(
  selectUpdateFacilityViolationFlagState,
  (state) => state.error
);

export const selectUpdateFacilityViolationFlagData = createSelector(
  selectUpdateFacilityViolationFlagState,
  (state) => state.data
);

const selectFacilityUserState = (state: { facilityUsers: IFacilityUserState }) => state.facilityUsers;

export const selectFacilityUsers = createSelector(
  selectFacilityUserState,
  (facilityUserState) => facilityUserState.list
);

export const selectFacilityUsersLoading = createSelector(
  selectFacilityUserState,
  (facilityUserState) => facilityUserState.loading
);

export const selectFacilityUsersError = createSelector(
  selectFacilityUserState,
  (facilityUserState) => facilityUserState.error
);

const selectUpdateFacilityProfileState = (state: { updateFacilityProfile: IUpdateFacilityProfileState }) => state.updateFacilityProfile;

export const selectUpdateFacilityProfile = createSelector(
  selectUpdateFacilityProfileState,
  (updateFacilityProfileState) => updateFacilityProfileState.data
);

export const selectUpdateFacilityProfileLoading = createSelector(
  selectUpdateFacilityProfileState,
  (updateFacilityProfileState) => updateFacilityProfileState.loading
);

export const selectUpdateFacilityProfileError = createSelector(
  selectUpdateFacilityProfileState,
  (updateFacilityProfileState) => updateFacilityProfileState.error
);


const selectFacilityShiftHistoryState = (state: { facilityShiftHistory: IFacilityShiftHistoryState }) => state.facilityShiftHistory;

export const selectFacilityShiftHistory = createSelector(
  selectFacilityShiftHistoryState,
  (shiftHistoryState) => shiftHistoryState.data?.results || []
);

export const selectFacilityShiftHistoryCount = createSelector(
  selectFacilityShiftHistoryState,
  (shiftHistoryState) => shiftHistoryState.data?.count || 0
);

export const selectFacilityShiftHistoryLoading = createSelector(
  selectFacilityShiftHistoryState,
  (shiftHistoryState) => shiftHistoryState.loading
);

export const selectFacilityShiftHistoryError = createSelector(
  selectFacilityShiftHistoryState,
  (shiftHistoryState) => shiftHistoryState.error
);

export const selectFacilityShiftHistoryNext = createSelector(
  selectFacilityShiftHistoryState,
  (shiftHistoryState) => shiftHistoryState.data?.next
);

export const selectFacilityShiftHistoryPrevious = createSelector(
  selectFacilityShiftHistoryState,
  (shiftHistoryState) => shiftHistoryState.data?.previous
);

const selectFacilityReportStatsState = (state: { facilityReportStats: IFacilityReportStatsState }) => state.facilityReportStats;

export const selectFacilityReportStats = createSelector(
  selectFacilityReportStatsState,
  (statsState) => statsState.data
);

export const selectFacilityReportStatsLoading = createSelector(
  selectFacilityReportStatsState,
  (statsState) => statsState.loading
);

export const selectFacilityReportStatsError = createSelector(
  selectFacilityReportStatsState,
  (statsState) => statsState.error
);

const selectFacilityWorkerAttendanceState = (state: { facilityWorkerAttendance: IWorkerAttendanceState }) => state.facilityWorkerAttendance;

export const selectFacilityWorkerAttendanceList = createSelector(
  selectFacilityWorkerAttendanceState,
  (state) => state.data?.results || []
);

export const selectFacilityWorkerAttendanceCount = createSelector(
  selectFacilityWorkerAttendanceState,
  (state) => state.data?.count || 0
);

export const selectFacilityWorkerAttendanceLoading = createSelector(
  selectFacilityWorkerAttendanceState,
  (state) => state.loading
);


export const selectFacilityWorkerAttendanceError = createSelector(
  selectFacilityWorkerAttendanceState,
  (state) => state.error
);

const selectFacilityDashboardStatisticsState = (state: { facilityDashboardStatistics: IFacilityDashboardStatisticsState }) => state.facilityDashboardStatistics;

export const selectFacilityDashboardStatistics = createSelector(
  selectFacilityDashboardStatisticsState,
  (statsState) => statsState.data
);

export const selectFacilityDashboardStatisticsLoading = createSelector(
  selectFacilityDashboardStatisticsState,
  (statsState) => statsState.loading
);

export const selectFacilityDashboardStatisticsError = createSelector(
  selectFacilityDashboardStatisticsState,
  (statsState) => statsState.error
);

const selectFacilityShiftStatusChartState = (state: { facilityShiftStatusChart: IFacilityShiftStatusChartState }) => state.facilityShiftStatusChart;

export const selectFacilityShiftStatusChart = createSelector(
  selectFacilityShiftStatusChartState,
  (statsState) => statsState.data
);

export const selectFacilityShiftStatusChartLoading = createSelector(
  selectFacilityShiftStatusChartState,
  (statsState) => statsState.loading
);

export const selectFacilityShiftStatusChartError = createSelector(
  selectFacilityShiftStatusChartState,
  (statsState) => statsState.error
);


const selectFacilityShiftCalendarState = (state: { facilityShiftCalendar: IFacilityShiftCalendarState }) => state.facilityShiftCalendar;

export const selectFacilityShiftCalendar = createSelector(
  selectFacilityShiftCalendarState,
  (calendarState) => calendarState.data
);

export const selectFacilityShiftCalendarLoading = createSelector(
  selectFacilityShiftCalendarState,
  (calendarState) => calendarState.loading
);

export const selectFacilityShiftCalendarError = createSelector(
  selectFacilityShiftCalendarState,
  (calendarState) => calendarState.error
);

const selectFacilityAssignedWorkersState = (state: { facilityAssignedWorkers: IFacilityAssignedWorkersState }) => state.facilityAssignedWorkers;

export const selectFacilityAssignedWorkers = createSelector(
  selectFacilityAssignedWorkersState,
  (assignedWorkersState) => assignedWorkersState.data
);

export const selectFacilityAssignedWorkersLoading = createSelector(
  selectFacilityAssignedWorkersState,
  (assignedWorkersState) => assignedWorkersState.loading
);

export const selectFacilityAssignedWorkersError = createSelector(
  selectFacilityAssignedWorkersState,
  (assignedWorkersState) => assignedWorkersState.error
);
